import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../utils/api";

const initialState = {
  loading: false,
  error: false,
  paymentDetails:null
};


export const initiatePayment = createAsyncThunk(
  "initiatePayment",
  async (userId) => {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${baseUrl}/transaction/process?userId=${userId}`,
        headers: {
          "content-type": "application/json",
        },
      });
      return data;
    } catch (error) {
      // api.error({
      //   message: "Internal Server Error",
      // });
      console.log(error);
    }
  }
);

export const verifyPayment = createAsyncThunk("verifyPayment", async (txRef) => {
  try {
    const { data } = await axios({
      method: "GET",
      url: `${baseUrl}/transaction/verify?txRef=${txRef}`,

      headers: {
        "content-type": "application/json",
      },
    });
    return data;
  } catch (error) {
    // api.error({
    //   message: "Internal Server Error",
    // });
  }
});

const paymentSlice = createSlice({
  name: "paymentSlice",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(initiatePayment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(initiatePayment.fulfilled, (state, action) => {
      state.loading = false;
    state.paymentDetails=action?.payload
    });
    builder.addCase(initiatePayment.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(verifyPayment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(verifyPayment.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(verifyPayment.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default paymentSlice.reducer;
